export default {
    apiKey: process.env.BUGSNAG_API_KEY || '',
};
